'use strict';

/**
 * @ngdoc overview
 * @name prepApp
 * @description
 * # prepApp
 *
 * Main module of the application.
 */
angular
    .module('prepApp')
    .config(function ($routeProvider, $resourceProvider, momentPickerProvider) {
        $routeProvider
            .when('/', {
                controller: 'HomeController',
                templateUrl: 'views/home.html',
                controllerAs: 'homeCtrl',
                name: 'Home',
                publicAccess: true
            })
            .when('/taskTemplate', {
                controller: 'TaskTemplateController',
                templateUrl: 'views/tasktemplate.html',
                controllerAs: 'taskTemplateCtrl',
                name: 'Aufgaben-Vorlage'
            })
            .when('/course', {
                templateUrl: 'views/course.html',
                controller: 'CourseController',
                controllerAs: 'courses',
                name: 'Lehrgänge'
            })
            .when('/courseTasks', {
                templateUrl: 'views/coursetasks.html',
                controller: 'CourseTasksController',
                controllerAs: 'courseTasks',
                name: 'Aufgaben-Lehrgang'
            })
            .when('/courseTask/:courseId', {
                templateUrl: 'views/coursetask.html',
                controller: 'CourseTaskController',
                controllerAs: 'courseTask'
            })
            .when('/courseTasksDay', {
                templateUrl: 'views/coursetasksday.html',
                controller: 'CourseTasksDayController',
                controllerAs: 'courseTasksDay',
                name: 'Aufgaben-Tag'
            })
            .when('/logout', {
                // A template or templateUrl is required by AngularJS, even if your controller always redirects.
                template: '',
                controller: function (Auth) {
                    Auth.logout();
                },
                controllerAs: 'logout'
            })
            .otherwise({
                redirectTo: '/'
            });
        // Don't strip trailing slashes from calculated URLs
        $resourceProvider.defaults.stripTrailingSlashes = false;
        momentPickerProvider.options({
            format: 'L LTS',
            startView: 'month'
        });
    })
    .run(function ($rootScope, $location, $route, Auth) {
        var routesOpenToPublic = [];
        angular.forEach($route.routes, function (route, path) {
            // push route onto routesOpenToPublic if it has a truthy publicAccess value
            if (route.publicAccess) {
                routesOpenToPublic.push(path);
            }
            // route.publicAccess && (routesOpenToPublic.push(path));
        });

        var routeChange = $rootScope.$on('$routeChangeStart', function () {
            var closedToPublic = (routesOpenToPublic.indexOf($location.path()) === -1);
            if (closedToPublic && !Auth.isLoggedIn()) {
                $location.path('/login');
            }
        });
        // clean up listener when directive's scope is destroyed
        $rootScope.$on('$destroy', routeChange);
    });
